// components/ThemeSelector.js - Enkel tema-velger
import React, { useState } from 'react';
import { Palette, Check, ChevronDown } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';

const ThemeSelector = () => {
  const { currentTheme, themeInfo, changeTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const handleThemeChange = (themeId) => {
    changeTheme(themeId);  // ← DETTE ER ALT DU TRENGER!
    setIsOpen(false);
  };

  return (
    <div className="relative">
      {/* Trigger Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
        aria-label="Velg fargetema"
      >
        <Palette className="w-5 h-5 text-gray-600" />
        <span className="text-sm font-medium text-gray-700 hidden sm:block">
          {themeInfo.find(t => t.id === currentTheme)?.name || 'Tema'}
        </span>
        <ChevronDown className="w-4 h-4 text-gray-500" />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute top-full right-0 mt-2 w-72 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <div className="p-3 border-b border-gray-100">
            <h3 className="text-sm font-semibold text-gray-800">Velg fargetema</h3>
            <p className="text-xs text-gray-600 mt-1">
              Endrer utseendet til hele siden
            </p>
          </div>

          <div className="p-2 space-y-1">
            {themeInfo.map((theme) => {
              const isSelected = currentTheme === theme.id;

              return (
                <button
                  key={theme.id}
                  onClick={() => handleThemeChange(theme.id)}
                  className={`w-full text-left p-3 rounded-lg transition-all hover:bg-gray-50 ${
                    isSelected ? 'bg-blue-50 border border-blue-200' : 'border border-transparent'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex-1">
                      {/* Tema navn */}
                      <div className="flex items-center space-x-3 mb-2">
                        <span className="text-sm font-medium text-gray-800">
                          {theme.name}
                        </span>
                        {isSelected && (
                          <Check className="w-4 h-4 text-blue-600" />
                        )}
                      </div>
                      
                      {/* Beskrivelse */}
                      <div className="text-xs text-gray-600 mb-3">
                        {theme.description}
                      </div>

                      {/* Fargeforhåndsvisning */}
                      <div className="flex space-x-1">
                        {theme.preview.map((color, index) => (
                          <div
                            key={index}
                            className="w-6 h-6 rounded-full border border-gray-200"
                            style={{ backgroundColor: color }}
                            title={`Farge ${index + 1}`}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </button>
              );
            })}
          </div>

          {/* Info */}
          <div className="p-3 border-t border-gray-100 bg-gray-50">
            <div className="text-xs text-gray-500">
              💡 Ditt valg lagres automatisk
            </div>
          </div>
        </div>
      )}

      {/* Bakgrunnsklikk for å lukke */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

// ALTERNATIV: Enkel knapp-versjon
export const SimpleThemeButtons = () => {
  const { currentTheme, themeInfo, changeTheme } = useTheme();

  return (
    <div className="flex space-x-2">
      {themeInfo.map((theme) => (
        <button
          key={theme.id}
          onClick={() => changeTheme(theme.id)}  // ← DETTE ER ALT DU TRENGER!
          className={`px-3 py-2 text-xs rounded-lg border transition-colors ${
            currentTheme === theme.id
              ? 'bg-blue-500 text-white border-blue-500'
              : 'bg-white text-gray-700 border-gray-300 hover:border-blue-300'
          }`}
          title={theme.description}
        >
          {theme.name}
        </button>
      ))}
    </div>
  );
};

// ALTERNATIV: Fargeprøver som knapper
export const ColorSwatchSelector = () => {
  const { currentTheme, themeInfo, changeTheme } = useTheme();

  return (
    <div className="flex space-x-2">
      {themeInfo.map((theme) => (
        <button
          key={theme.id}
          onClick={() => changeTheme(theme.id)}  // ← DETTE ER ALT DU TRENGER!
          className={`w-8 h-8 rounded-full border-2 transition-all hover:scale-110 ${
            currentTheme === theme.id ? 'border-gray-800' : 'border-gray-300'
          }`}
          style={{ backgroundColor: theme.preview[0] }}
          title={`${theme.name} - ${theme.description}`}
        />
      ))}
    </div>
  );
};

export default ThemeSelector;